/**
 * @fileoverview > handler for the "/engagement/:app_group_id/transactional_web_push_test" endpoint
 * @owner @Appboy/email
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdTransactionalWebPushTestCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdTransactionalWebPushTestProps,
  TransactionalWebPushTestResponse,
} from "./types";

export const postEngagementAppGroupIdTransactionalWebPushTest = reactQueryMutationAdapter(
  engagementAppGroupIdTransactionalWebPushTestCacheKeys,
  ({
    appGroupId,
    company_id,
    web_push_url,
  }: PostEngagementAppGroupIdTransactionalWebPushTestProps): Promise<TransactionalWebPushTestResponse> => {
    return fetch(`/engagement/${appGroupId}/transactional_web_push_test`, "POST", { company_id, web_push_url });
  }
);
